import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/v2`;

function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();

  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('systemklar_language', lng);
    
    // Save to backend if logged in
    const token = localStorage.getItem('systemklart_token');
    if (token) {
      try {
        await axios.patch(`${API}/auth/users/me/language`, 
          { language: lng },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (error) {
        console.error('Failed to save language preference:', error);
      }
    }
  };

  const currentLanguage = i18n.language?.substring(0, 2) || 'nb';

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <button
        onClick={() => changeLanguage('nb')}
        className={`px-2 py-1 text-xs rounded transition-colors ${
          currentLanguage === 'nb'
            ? 'bg-blue-100 text-blue-700 font-medium'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
        }`}
        title="Norsk"
        data-testid="lang-nb"
      >
        NO
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-2 py-1 text-xs rounded transition-colors ${
          currentLanguage === 'en'
            ? 'bg-blue-100 text-blue-700 font-medium'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
        }`}
        title="English"
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher;
